import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLicenses, createLicense, activateLicense, deactivateLicense } from '../../services/api';

const empty = {
  clientName: '', clientEmail: '', maxUsers: '', uniqueUserWindowDays: '30',
  validFrom: new Date().toISOString().slice(0, 10),
  validUntil: ''
};

export default function LicensesPage() {
  const [licenses, setLicenses] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const load = () => getLicenses().then(setLicenses);
  useEffect(() => { load(); }, []);

  const handleCreate = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await createLicense({
        ...form,
        maxUsers: parseInt(form.maxUsers),
        uniqueUserWindowDays: parseInt(form.uniqueUserWindowDays) || 30,
        validFrom: form.validFrom + 'T00:00:00',
        validUntil: form.validUntil + 'T23:59:59',
      });
      setShowForm(false);
      setForm(empty);
      load();
    } finally {
      setSaving(false);
    }
  };

  const toggle = async (id, active) => {
    if (active) await deactivateLicense(id);
    else await activateLicense(id);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0 }}>Licences</h1>
        <button onClick={() => setShowForm(!showForm)} style={primaryBtn}>
          {showForm ? '✕ Annuler' : '+ Nouvelle licence'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} style={{ ...card, marginBottom: '1.5rem', display: 'grid', gap: '1rem', gridTemplateColumns: '1fr 1fr' }}>
          <div style={{ gridColumn: '1 / -1', fontWeight: 600, color: '#6b7280' }}>Nouvelle licence</div>
          <Field label="Nom du client" value={form.clientName} onChange={v => setForm({ ...form, clientName: v })} required />
          <Field label="Email" type="email" value={form.clientEmail} onChange={v => setForm({ ...form, clientEmail: v })} required />
          <Field label="Quota utilisateurs" type="number" value={form.maxUsers} onChange={v => setForm({ ...form, maxUsers: v })} required />
          <Field label="Fenêtre utilisateurs uniques (jours)" type="number" value={form.uniqueUserWindowDays} onChange={v => setForm({ ...form, uniqueUserWindowDays: v })} required />
          <Field label="Valide à partir du" type="date" value={form.validFrom} onChange={v => setForm({ ...form, validFrom: v })} required />
          <Field label="Valide jusqu'au" type="date" value={form.validUntil} onChange={v => setForm({ ...form, validUntil: v })} required />
          <div style={{ gridColumn: '1 / -1', textAlign: 'right' }}>
            <button type="submit" disabled={saving} style={primaryBtn}>
              {saving ? 'Enregistrement...' : 'Créer la licence'}
            </button>
          </div>
        </form>
      )}

      <div style={{ ...card, overflowX: 'auto' }}>
        <table style={{ width: '100%', minWidth: '960px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: '#8a8f99', fontSize: '0.8rem', textTransform: 'uppercase', borderBottom: '1px solid #cdcdcd' }}>
              {['Client', 'Email', 'Clé', 'Quota', 'Users actifs', 'Fenêtre', 'Expire le', 'Statut', ''].map(h =>
                <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left' }}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {licenses.map(l => (
              <tr key={l.id} style={{ borderBottom: '1px solid #ececec' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}>
                <td style={td}>{l.clientName}</td>
                <td style={{ ...td, color: '#6b7280', fontSize: '0.85rem' }}>{l.clientEmail}</td>
                <td style={{ ...td, fontFamily: 'monospace', fontSize: '0.78rem', color: '#8a8f99' }}>{l.licenseKey}</td>
                <td style={td}>{l.maxUsers}</td>
                <td style={{ ...td, fontWeight: 700, color: l.currentUniqueUsers > l.maxUsers ? '#c62828' : '#444444' }}>
                  {l.currentUniqueUsers}
                </td>
                <td style={{ ...td, color: '#6b7280', fontSize: '0.85rem' }}>{l.uniqueUserWindowDays}j</td>
                <td style={{ ...td, fontSize: '0.85rem', color: '#6b7280' }}>
                  {new Date(l.validUntil).toLocaleDateString('fr-FR')}
                </td>
                <td style={td}>
                  <span style={{ background: l.active ? '#e2f3e8' : '#ffffff', color: l.active ? '#1a7f37' : '#8a8f99', padding: '2px 10px', borderRadius: '99px', fontSize: '0.78rem', fontWeight: 600 }}>
                    {l.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td style={{ ...td, display: 'flex', gap: '0.5rem' }}>
                  <button onClick={() => navigate(`/licenses/${l.id}`)} style={linkBtn}>Détail</button>
                  <button onClick={() => toggle(l.id, l.active)} style={l.active ? warnBtn : okBtn}>
                    {l.active ? 'Désactiver' : 'Activer'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = 'text', required }) {
  return (
    <div>
      <label style={{ display: 'block', color: '#6b7280', fontSize: '0.8rem', marginBottom: '4px' }}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        required={required}
        style={{ width: '100%', padding: '0.6rem', background: '#f5f5f5', border: '1px solid #cdcdcd', color: '#444444', borderRadius: '6px', boxSizing: 'border-box' }}
      />
    </div>
  );
}

const card = { background: '#ffffff', borderRadius: '12px', padding: '1.5rem' };
const td = { padding: '0.85rem 1rem', color: '#444444' };
const primaryBtn = { padding: '0.5rem 1.25rem', background: '#232853', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' };
const linkBtn = { padding: '0.3rem 0.75rem', background: 'transparent', border: '1px solid #cdcdcd', color: '#005cc5', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' };
const warnBtn = { padding: '0.3rem 0.75rem', background: '#fff4e0', border: '1px solid #ecc889', color: '#955d00', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' };
const okBtn = { padding: '0.3rem 0.75rem', background: '#e2f3e8', border: '1px solid #a7d7b4', color: '#1a7f37', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' };
